
$soupmail.string = {
	
	basicHtmlEscape : function($str, $default) {
		if (!$str || ($str == null)) { return $default; }
		return $str.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
	},
	
	emailAddressHtmlEscape : function($addresses, $mailtoLink) {
		var $str = '';
		
		function assembleString($address, $mailtoLink) {
			var thisStr = '';
			if ($mailtoLink && $address.email) { thisStr += '<a href="mailto:'+($address.email)+'">'; }
			var emailAddressBrackets = ($address.email ? ' <span>&lt;'+$address.email+'&gt;</span>' : '');
			var emailAddressPlain = ($address.email ? $address.email : '-- no email address --');
			thisStr += ($address.display_name ? ($address.display_name + emailAddressBrackets) : emailAddressPlain);
			if ($mailtoLink && $address.email) { thisStr += '</a>'; }
			return thisStr;
		}
		
		if ($addresses && ($addresses.length > 0)) {
			// Multiple Addresses
			jQuery.each($addresses, function($key, $address) {
				$str += assembleString($address, $mailtoLink);
				if ($addresses.length > ($key+1)){ $str += ', '; }
			});
		} else if ($addresses) {
			// Single Address
			$str += assembleString($addresses, $mailtoLink);
		}
		return $str;
	},
	
	nl2br : function(str, is_xhtml) {
		var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
		return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
	},
	
	addslashes : function($str) {
		return $str.replace(/\'/gi, "&#39;").replace(/\"/gi, "&quot;");
	},
	
	dashesToUnderscores : function($str) {
		if (typeof($str) == 'number') { $str = ''+$str; }
		if (typeof($str) != 'string') { return 'undefined'; }
		return $str.replace(/\-/gi, '_');
	},
	
	stringUrlSafe : function($str) {
		if (typeof($str) == 'number') { $str = ''+$str; }
		if (typeof($str) != 'string') { return 'undefined'; }
		return $str.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase();
	},
	
	stringHtmlAttributeSafe : function($str) {
		if (typeof($str) == 'number') { $str = ''+$str; }
		if (typeof($str) != 'string') { return 'undefined'; }
		return $str.replace(/[^a-zA-Z0-9]+/g, '_').toLowerCase();
	},
	
	makeEmailClassesScoped : function($html) {
		// first make sure that all attributes are quoted.... http://stackoverflow.com/a/7687937/1227297
		$html = $html.replace(/([\w-]+)=([\w-]+)([ >])/g, function(str, $attribute, $value, $extra, offset, s) {
			return $attribute + '="' + $value + '"' + $extra;
		});
		// then inline all of the class'es and id's
		$html = $html.replace(/ class="/gi, ' class="soup-inline-');
		$html = $html.replace(/ class='/gi, " class='soup-inline-");
		$html = $html.replace(/ id="/gi,    ' id="soup-inline-');
		$html = $html.replace(/ id='/gi,    " id='soup-inline-");
		return $html;
	},
	
	makeEmailStylesScoped : function() {
		jQuery('#soupmail-email-preview style').each(function() {
			thisStyles = jQuery(this).html();
			thisStyles = thisStyles.replace(/ /gi, '').replace(/\r/gi, '').replace(/\n/gi, '').replace(/\t/gi, '');
			thisStyles = thisStyles.replace(/<!--/g, '');
			thisStyles = thisStyles.replace(/-->/g, '');
			thisStyles = thisStyles.replace(/.0pt/g, 'pt').replace(/.0001pt/g, 'pt');
			thisStyles = thisStyles.replace(/\/\*.+?\*\/|\/\/.*(?=[\n\r])/g, '');
			thisStyles = thisStyles.replace(/[.]/g, '.soup-inline-');
			thisStyles = thisStyles.replace(/[}]/g, '} #soupmail-email-preview .body ');
			thisStyles = thisStyles.replace(/[,]/g, ', #soupmail-email-preview .body ');
			thisStyles = '#soupmail-email-preview .body ' + thisStyles + '{}';
			jQuery(this).html(thisStyles);
		});
	},
	
	makeHTTPresourcesNotLoad : function($html) {
		$html = $html.replace(/src\=\"http\:\/\//gi, 'src="'+ $soupmail.images["placeholder.gif"] +'" data-src="http://');
		$html = $html.replace(/src\=\'http\:\/\//gi, 'src="'+ $soupmail.images["placeholder.gif"] +'" data-src="http://');
		return $html;
	},
	
	containsHTTPresources : function($html) {
		if ($html.indexOf('src="http://') > 0) { return true; }
		if ($html.indexOf('src=\'http://') > 0) { return true; }
		return false;
	},
	
	removeScriptTags : function($html) {
		$html = $html.replace(/\<script/gi, '<code');
		$html = $html.replace(/\/script/gi, '/code');
		return $html;
	},
	
	ucfirst : function($val) {
		return $val.charAt(0).toUpperCase() + $val.slice(1);
	},
	
	extractEmailDomain : function($emailAddress) {
		var emailBits = $emailAddress.split('@');
		emailBits.shift();
		return emailBits.join('');
	},
	
	isPositiveInteger : function(n) {
		if (parseFloat(n) === 0) { return false; }
		return n >>> 0 === parseFloat(n);
	},
	
	isValidEmailAddress : function($emailAddress) {
		var validator = new $soupmail.validator();
		return validator.validateEmail($emailAddress);
	},
	
	implodeObjectList : function($glue, $pieces, $key1, $key2) {
		var simpleArr = [];
		jQuery.each($pieces, function($k, $v) {
			var str = '';
			if ($key1) { str += $v[$key1]; }
			if ($key1 && $key2) { str += ' '; }
			if ($key2) { str += $v[$key2]; }
			simpleArr.push(str);
		});
		return simpleArr.join($glue);
	}
	
}



// WEBPACK FOOTER //
// ./src/js/helpers/soupmail.helper.stringutils.js